import { Box, styled } from '@material-ui/core';
import { SButton, SText } from '@setvi/shared/components';
import CloseIcon from '@material-ui/icons/Close';
import { Facets, FacetsProps } from '../../facets';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(0, 2),
  marginBottom: theme.spacing(2),
  height: 28,
  minHeight: 28,
  marginTop: 12
}));

export const FiltersContent = ({
  facets,
  selectedCategory,
  loading,
  attributesForFaceting,
  selectedFacets,
  globalSearch,
  onSelectFacet
}: FacetsProps) => (
  <>
    <Container>
      <SText
        lineHeight="20px"
        size="sm"
        weight="bold"
        title={`Filters ${selectedFacets.length ? `(${selectedFacets.length})` : ''}`}
      />
      {selectedFacets.length > 0 && (
        <SButton
          variant="text"
          style={{ minHeight: 'max-content', padding: '2px 8px', fontSize: 12 }}
          startIcon={<CloseIcon />}
          onClick={() => onSelectFacet(false, selectedFacets)}>
          Clear All
        </SButton>
      )}
    </Container>
    <Facets
      globalSearch={globalSearch}
      onSelectFacet={onSelectFacet}
      selectedCategory={selectedCategory}
      facets={facets}
      loading={loading}
      selectedFacets={selectedFacets}
      attributesForFaceting={attributesForFaceting}
    />
  </>
);
